/* Starniri: one shared star name for the whole site (v4b, 23 Oct 2026).
   window.snrStarName = { get(), set(v), subscribe(fn) }, saved in localStorage['snr:starName'].
   - set(): trims, collapses spaces, caps at 60 characters, saves, updates every bound input and
     every [data-star-name] element, and fires 'snr:starname' on document.
   - Mirrors into the older snr_name key through window.snrName (snr-name.js), so the hero headline,
     #how demo, engraving and sky previews (which listen for 'snr:name') and the basket line item
     property "Star name" all use the same name. Mirroring is debounced ~150ms so canvases redraw
     once typing stops.
   - Other tabs stay in sync through the 'storage' event.
   - Cleared after an order: when a checkout was started and the cart later comes back empty.
   Load AFTER snr-name.js (both deferred). */
(function () {
  'use strict';
  var K = 'snr:starName', KC = 'snr:checkoutAt', MAX = 60, FALL = 'Your star';
  var IN = '[data-snr-namebox] input[name="name"],.ssc [data-name],[data-star-name-in],input[name="properties[Star name]"],#gp-n1';
  var PROD = 'input[name="properties[Star name]"],#gp-n1';
  var CAP = '[data-snr-namebox] input[name="name"],.ssc [data-name],[data-star-name-in]';
  function rd(k) { try { return localStorage.getItem(k) || ''; } catch (e) { return ''; } }
  function wr(k, v) { try { v ? localStorage.setItem(k, v) : localStorage.removeItem(k); } catch (e) {} }
  function norm(v) { return String(v || '').replace(/\s+/g, ' ').trim().slice(0, MAX); }
  var subs = [], val = norm(rd(K)), mt;
  if (!val && window.snrName && snrName.get) { val = norm(snrName.get()); if (val) wr(K, val); }

  function inputs() { return document.querySelectorAll(IN); }
  function render(src) {
    inputs().forEach(function (i) {
      if (i === src || i.type === 'hidden') return;
      if (CAP && i.matches(CAP)) i.maxLength = MAX;
      // Never overwrite a field the customer is typing in, and leave longer product-page names alone.
      if (i === document.activeElement) return;
      if (i.matches(PROD)) return; // product pages: snr-name.js prefills these; never truncate them here
      if (norm(i.value) !== val) i.value = val;
    });
    document.querySelectorAll('[data-star-name]').forEach(function (el) {
      var t = val || el.getAttribute('data-star-name-fallback') || FALL;
      if (el.textContent !== t) el.textContent = t;
    });
    try { document.dispatchEvent(new CustomEvent('snr:starname', { detail: { name: val } })); } catch (e) {}
    subs.forEach(function (fn) { try { fn(val); } catch (e) {} });
  }
  function mirror() {
    clearTimeout(mt);
    mt = setTimeout(function () {
      if (!window.snrName) { wr('snr_name', val); return; }
      if ((snrName.get() || '') === val) return;
      if (val) snrName.set(val); else { wr('snr_name', ''); snrName.set(''); }
    }, 150);
  }
  function set(v, src) {
    var n = norm(v), prod = src && src.matches && src.matches(PROD);
    if (n === val) { render(src); return; }
    val = n; wr(K, val); render(src);
    if (!prod) mirror(); // snr-name.js already saves product-page typing in full
  }
  window.snrStarName = {
    get: function () { return val; },
    set: function (v) { set(v); },
    subscribe: function (fn) { if (typeof fn === 'function') { subs.push(fn); fn(val); } return function () { subs = subs.filter(function (f) { return f !== fn; }); }; }
  };

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!e.isTrusted || !t.matches || !t.matches(IN)) return;
    set(t.value, t);
  }, true);
  document.addEventListener('change', function (e) {
    var t = e.target; if (t.matches && t.matches(IN) && e.isTrusted) set(t.value, t);
  }, true);
  window.addEventListener('storage', function (e) {
    if (e.key !== K) return;
    var n = norm(e.newValue); if (n === val) return;
    val = n; render(null); mirror();
  });

  // Clear after an order. Checkout and the thank-you page run outside the theme, so: remember when the
  // customer heads to checkout, then if they come back to the shop and the cart is empty, the order went through.
  document.addEventListener('submit', function (e) {
    var f = e.target, b = e.submitter;
    if ((f.action && /\/checkout/.test(f.action)) || (b && b.name === 'checkout')) wr(KC, String(Date.now()));
  }, true);
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="/checkout"],button[name="checkout"]');
    if (a) wr(KC, String(Date.now()));
  }, true);
  function afterOrder() {
    var at = +rd(KC); if (!at || !window.fetch) return;
    if (Date.now() - at > 14 * 864e5) { wr(KC, ''); return; }
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      if (c && c.item_count === 0) {
        wr(KC, ''); val = ''; wr(K, '');
        if (window.snrName && snrName.clear) snrName.clear(); else wr('snr_name', '');
        render(null);
      }
    }).catch(function () {});
  }

  function boot() {
    // An unsaved name already typed or prefilled (?name=) wins over nothing.
    if (!val) { var q = ''; try { q = new URLSearchParams(location.search).get('name') || ''; } catch (e) {} if (q) { val = norm(q); wr(K, val); mirror(); } }
    render(null);
    afterOrder();
    if (window.MutationObserver) new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) for (var j = 0; j < m[i].addedNodes.length; j++) {
        var n = m[i].addedNodes[j];
        if (n.nodeType === 1 && (n.matches(IN + ',[data-star-name]') || n.querySelector(IN + ',[data-star-name]'))) { render(null); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
